<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <div class="column content-box">
      <woot-modal-header :header-title="$t('SURVEY_MGMT.RESPONSE.HEADER')" />

      <div>
        <div class="main-form">
          <div>
            <span class="span-label">
              <form @submit.prevent="saveModel">
                <div v-for="(question, index) in model.questions" :key="index" class="question-container">
                  <woot-input v-if="question.type === 'text'" class="input-text question-input"
                    v-model.trim="question.response" :label="`${question.question}`" type="text"
                    readonly=true />
                  <div v-if="question.type == 'rating'" class="rating-container">
                    <label>{{ question.question }}</label>
                    <rating-view :selected-rating="question.response" />
                  </div>
                  <div v-if="question.type == 'rating_a'" class="rating-container">
                    <label>{{ question.question }}</label>
                    <ten-rating-view :selected-rating="question.response" />
                  </div>
                  <div v-if="question.type === 'yesnot'" class="yesnot-container">
                    <label>{{ question.question }}</label>
                    <div class="yesnot-options">
                      <label>
                        <input type="radio" :checked="question.response === 'true'" disabled />
                        {{ $t('SURVEY_MGMT.YES') }}
                      </label>
                      <label>
                        <input type="radio" :checked="question.response === 'false'" disabled />
                        {{ $t('SURVEY_MGMT.NO') }}
                      </label>
                    </div>
                  </div>
                </div>
              </form>
            </span>
          </div>
        </div>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import RatingView from './RatingView.vue';
import TenRatingView from './TenRatingView.vue';

export default {
  mixins: [alertMixin],
  components: {
    RatingView,
    TenRatingView,
  },
  props: {
    editModel: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      show: true,
      showDeleteTablePopup: false,
      model: this.editModel ? { ...this.editModel } : {
        name: '',
        description: '',
        logoUrl: '',
        questions: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      uiFlags: 'getUIFlags',
      currentUser: 'getCurrentUser',
      indexTab: 'attributes/getIndexTabAttributes',
    }),
    deleteRejectText() {
      return this.$t('SURVEY_MGMT.NO');
    },
    isEdit() {
      return !!this.editModel;
    },
  },
  methods: {
    closeDeleteGroup() {
      this.showDeleteTablePopup = false;
      this.selectedAttribute = {};
    },
    async deleteTable(id) {
      try {
        await this.$store.dispatch('customSurveys/deleteModel', {
          id: id,
        });
        this.showAlert(this.$t('SURVEY_MGMT.SURVEY.DELETE.SUCCESS_MESSAGE'));
      } catch (error) {
        const errorMessage =
          error?.response?.message ||
          this.$t('SURVEY_MGMT.SURVEY.DELETE.ERROR_MESSAGE');
        console.log(error)
        this.showAlert(errorMessage);
      }
    },
    confirmTableDeletion() {
      this.deleteTable(this.model.id);
      this.closeDeleteGroup();
    },
    openDeleteTable() {
      this.showDeleteTablePopup = true;
    },
    onClose() {
      this.$emit('on-close');
    },
    async saveModel() {
      try {
        await this.$store.dispatch('customSurveys/updateModel',
          this.model
        );
        this.onClose();
      } catch (error) {
        console.error('Erro ao processar', error);
        throw error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-form {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.span-label {
  width: 100%;
  margin-bottom: 5px;
}

.question-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.question-input {
  width: 100%;
  margin-bottom: 15px;
}

.rating-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 15px;
}

.yesnot-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 25px;
}

.yesnot-options {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 10px;
}

.yesnot-options label {
  display: flex;
  align-items: center;
  gap: 5px;
}

.question-options {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}
</style>